import { render } from "./ExchangeResult.vue?vue&type=template&id=1bc5dada&scoped=true&ts=true"
import script from "./ExchangeResult.vue?vue&type=script&lang=ts"
export * from "./ExchangeResult.vue?vue&type=script&lang=ts"

import "./ExchangeResult.vue?vue&type=style&index=0&id=1bc5dada&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc5dada"]])

export default __exports__